import React from 'react';
import moment from 'moment';

const stringToDate = (str) => {
  const dt = `01 ${str}`;

  return moment(dt).toDate();
};

const useFilterByDate = (obj, from, to) => {
  const filteredData = JSON.parse(JSON.stringify(obj));

  const x1 = [];
  const y1 = [];
  const markerColor = [];
  const pullouts = [];

  obj.data[0].customdata.forEach((item, i) => {
    const itemDate = stringToDate(item[2]);

    if (itemDate >= from && itemDate <= to) {
      x1.push(obj.data[0].x[i]);
      y1.push(obj.data[0].y[i]);
      markerColor.push(obj.data[0].marker.color[i]);
      pullouts.push(obj.data[0].customdata[i]);
    }
  });

  filteredData.data[0].customdata = pullouts;
  filteredData.data[0].x = x1;
  filteredData.data[0].y = y1;
  filteredData.data[0].marker.color = markerColor;

  return filteredData;
};

export default useFilterByDate;
